import posthog from "posthog-js";

export function identifyByEmailPostHog(email: string) {
  posthog.identify(email, { email })
}
